import http from 'utils/http';

export async function postAdon(body: any) {
  const res = http.post('/admin/createaddon', body);
  return (await res).data;
}
